export const parseValueToNumber = (value: string): number => {
  return Number(value?.replace(/[^\d]/g, ''));
};

export const isNumberInRange = (x: number, min: number, max: number): boolean => {
  return x >= min && x <= max;
};
